/*
const generateSrcset = (image, widths = []) => {
	const imageUrl = new URL(image["src"]);
	return widths
		.filter((width) => width <= image["width"])
		.map((width) => {
			imageUrl.searchParams.set("width", width.toString());
			return `${imageUrl.href} ${width}w`;
		})
		.join(", ");
};

const createImageElement = (image, classes, sizes, productTitle) => {
	const previewImage = image["preview_image"];
	const newImage = new Image(previewImage["width"], previewImage["height"]);
	newImage.className = classes;
	newImage.alt = image["alt"] || productTitle;
	newImage.sizes = sizes;
	newImage.src = previewImage["src"];
	newImage.srcset = generateSrcset(
		previewImage,
		[165, 360, 533, 720, 940, 1066]
	);
	newImage.loading = "lazy";
	return newImage;
};*/

const checkSwatches = () => {
	document.querySelectorAll(".js-color-swatches-wrapper").forEach((wrapper) => {
		wrapper.querySelectorAll(".js-color-swatches label").forEach((input) => {
			input.addEventListener("click", (event) => {
				const color = input.getAttribute('val')
				console.log('color '+color)
				const product = input.getAttribute('product')
				const secondProduct = input.getAttribute('secondproduct')
				// console.log(input)
				console.log('.media-'+product+'.second-product-'+secondProduct)
				$('.media-' + product).attr('style','object-fit: contain;z-index: 0;')
				$('.media-'+product+'.second-product-'+secondProduct).css('display','block')
				$('.media-'+product+'.second-product-'+secondProduct).first().css('opacity','1')
				$('.media-' + product).not($('.media-' + product + '.second-product-'+secondProduct)).css('display','none')
				let url = $(input).attr('url')
				var productCard = $(input).closest('.collection-product-card');
				productCard.find('label').removeClass('round-border')
				$(input).addClass('round-border')
				console.log(url)
				productCard.find('a').each(function() {
					$(this).attr('href', url);
				});
				var variantsInfo = JSON.parse(document.getElementById('variants_data_'+product).textContent);
				let sizes = []
				let productPrice
				let productCompare
				let mainProduct
                let isAvailable = false
				let hasDiscount = false

				// atoms FRONT-WISHLIST-SHOPIFY-01

				if(window.wishlist_parse != null){
					const wish_product_id = input.getAttribute('secondproduct');
					const wish_variant_id = input.getAttribute('variantproduct');
					const wish_product_handle = input.getAttribute('url').replace('/products/', '');
	
					const button_wishlist = wrapper.querySelector('.c-button-wishlist');
					button_wishlist.dataset.wishlist__id = wish_product_id;
					button_wishlist.dataset.wishlist__variant = wish_variant_id;
					button_wishlist.dataset.wishlist__handle = wish_product_handle;
	
					button_wishlist.dataset.wishlist__active = 'false';
					window.wishlist_parse.items.forEach(item => {
						if(item.product_id == wish_product_id){
							button_wishlist.dataset.wishlist__active = 'true';
						}
					  });
				}

				//
              	let totalInventoryColor = 0; 
				let section_id
				for(const variant of variantsInfo){
					if(variant.product == secondProduct){
						if(variant.available){
							sizes.push(variant.title)
						}
                      if(variant.available){
                        isAvailable = true
                        }
						productPrice = variant.product_price
						productCompare = variant.product_compare_at_price
						mainProduct = variant.main
						section_id = variant.section_id
                      if(variant.has_discount){
                        hasDiscount = true
                      }
					    totalInventoryColor += parseInt(variant.inventory_quantity || 0);
					}
				}
				let variantMain = variantsInfo[0].main
				if(!isAvailable){
					$('#'+section_id+'-so-'+variantMain).removeClass('d-none')
				}
				else{
					$('#'+section_id+'-so-'+variantMain).addClass('d-none')
				}
				console.log(sizes)
				$(input).closest('.collection-product-card').find('.size__modal').empty()
                if(isAvailable){
                  for(const size of sizes){
                      $(input).closest('.collection-product-card').find('.size__modal').append('<div class="size__btn" data-variantcolor="'+color+'" data-product="'+product+'" data-secondproduct="'+secondProduct+'" data-variantsize="'+size+'">'+size+'</div>')
                  }
                  //$(input).closest('.collection-product-card').find('.badge-out-of-stock').addClass('d-none')
                }
                else{
                  $(input).closest('.collection-product-card').find('.size__modal').append('<div class="out-of-stock">AGOTADO</div>')
                  //$(input).closest('.collection-product-card').find('.badge-out-of-stock').removeClass('d-none')
                }
				
				if(totalInventoryColor < 4){
					  $('.product-card-'+ mainProduct +' .pocas_piezas_value').css('display','block')
				}else{
					  $('.product-card-'+ mainProduct +' .pocas_piezas_value').css('display','none')

				}
				if(productCompare){console.log('Hay compare')
					$('.product-card-'+ mainProduct +' .price-item.price-item--regular').text(productCompare)
					$('.product-card-'+ mainProduct +' .price-item.price-item--sale').text(productPrice)
					$('.product-card-'+ mainProduct +' .price__sale').css('display','flex')
					$('.product-card-'+ mainProduct +' .price__regular').css('display','none')
					$('.product-card-'+ mainProduct +' .price').addClass('price--on-sale')
                   $('.product-card-'+ mainProduct +' .discount-badge').css('display','flex')
					
                   if(hasDiscount){
                   $('.product-card-'+ mainProduct +' .compare_badge').css('display','none')
                     const badge = `<?xml version="1.0" encoding="UTF-8"?>
<svg id="Capa_1" data-name="Capa 1" style="width:100%" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2644.84 1145.62">
  <defs>
    <style>
      .cls-1 {
        fill: #1e1e1c;
      }

      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5 {
        stroke-width: 0px;
      }

      .cls-2 {
        fill: #e11617;
      }

      .cls-3 {
        fill: #e1191a;
      }

      .cls-4 {
        fill: #fff;
      }

      .cls-5 {
        fill: #010101;
      }
    </style>
  </defs>
  <rect class="cls-5" x="201.38" y="295.84" width="1627.54" height="565.44"/>
  <g>
    <g>
      <g>
        <path class="cls-1" d="m1801.81,179.62l710.23,657.92s.75,40.58.75,79.73-42.4,35.42-42.4,35.42h-694.72c-39.14,0-35.43-44.74-35.43-44.74l6.14-659.15v-34.95s-.67-15.48,12.05-20.92c13.1-5.6,36.7-15.09,43.39-13.3Z"/>
        <path class="cls-1" d="m2422.03,915.27h-.09l-601.58-7.32c-3.93-.05-7.12-3.19-7.23-7.12l-19.82-713.77c-.06-2.18.85-4.28,2.5-5.71,1.64-1.44,3.83-2.06,6-1.72l689.53,111.63c3.43.55,6,3.44,6.14,6.91l23.74,536.26c.11,2.34-.92,4.59-2.75,6.05l-91.87,73.21c-1.3,1.03-2.91,1.59-4.57,1.59Zm-594.45-21.89l591.93,7.21,86.91-69.25-23.31-526.58-674.91-109.26,19.38,697.89Z"/>
        <polygon class="cls-4" points="1809.54 186.48 1809.21 777.44 2510.54 797.96 2487.79 300.19 1809.54 186.48"/>
        <polygon class="cls-2" points="1808.83 772.59 1808.83 902.35 2431.87 906.08 2512.03 831.51 2510.17 790.5 1808.83 772.59"/>
        <g>
          <polygon class="cls-4" points="2514.62 837.54 2434.91 841.8 2434.91 915.82 2514.62 837.54"/>
          <path class="cls-1" d="m2434.91,921.41c-.73,0-1.46-.14-2.16-.44-2.07-.87-3.42-2.9-3.42-5.15v-74.02c0-2.97,2.32-5.41,5.28-5.57l79.7-4.27c2.33-.11,4.47,1.2,5.41,3.32.94,2.12.46,4.61-1.2,6.23l-79.71,78.28c-1.06,1.05-2.48,1.61-3.91,1.61Zm5.58-74.32v55.43l59.7-58.62-59.7,3.19Z"/>
        </g>
        <g>
          <path class="cls-1" d="m1975.4,327.68c5.79.85,11.05,2.26,15.77,4.23,4.72,1.96,8.83,4.51,12.33,7.63,3.49,3.11,6.22,6.82,8.15,11.1,1.95,4.28,2.96,9.17,3.07,14.66.14,7.65-1.58,13.54-5.17,17.69-3.61,4.15-8.71,6.91-15.32,8.22v.61c4.73,1.27,8.78,3.05,12.14,5.34,3.37,2.3,6.04,4.87,8.03,7.72,1.99,2.85,3.48,5.91,4.43,9.16.97,3.25,1.47,6.42,1.53,9.49.53,27.98-17.55,40.1-54.24,36.38l-47.07-4.78-1.42-135.92,57.77,8.46Zm-24.09,22.9l.34,26.07,12.89,1.66c4.01.51,7.33-.35,9.92-2.59,2.59-2.23,3.87-5.1,3.81-8.64-.06-3.8-1.18-7.03-3.37-9.7-2.17-2.67-5.27-4.28-9.28-4.84l-14.32-1.96Zm1.06,80.26l16.29,1.81c4.86.53,8.67-.33,11.41-2.59,2.75-2.27,4.08-5.97,4-11.13-.05-3.11-1.28-6.12-3.69-9.05-2.4-2.93-6.45-4.74-12.14-5.42l-16.26-1.95.39,28.33Z"/>
          <path class="cls-1" d="m2143.62,452.29c-2.74,6.43-6.72,11.42-11.96,14.97-5.25,3.57-11.61,5.92-19.11,7.03-7.48,1.12-15.75,1.22-24.82.31-7.12-.71-14.11-2.01-20.97-3.88-6.87-1.88-13.01-4.99-18.46-9.31-5.45-4.34-9.88-10.19-13.29-17.54-3.41-7.36-5.23-16.83-5.46-28.45l-1.57-80.05,33.34,4.88,1.75,77.78c.2,9.1,2.37,15.92,6.5,20.47,4.13,4.54,10.3,7.25,18.53,8.15,8.35.92,14.77-.24,19.26-3.51,4.48-3.24,6.62-9.15,6.39-17.71l-2.1-77.81,33.33,4.88,2.27,75.58c.31,9.75-.91,17.81-3.63,24.22Z"/>
          <path class="cls-1" d="m2161.37,354.89l90.93,13.3,1.06,26.1-57.72-7.88.77,21.73,54.06,6.96,1,25.21-54.19-6.46.8,22.68,58.03,6.45,1.08,26.47-91.87-9.33-3.97-125.23Z"/>
          <path class="cls-1" d="m2303.63,375.69l56.49,83.24-3.88-75.54,30.85,4.5,6.33,115.36-38.93-3.95-55.98-81.84,3.46,76.52-30.97-3.15-5.05-120.67,37.68,5.51Z"/>
          <path class="cls-1" d="m1920.51,464.91l113.98,11.19.71,35.76-71.41-6.17.46,32.72,66.78,5.05.66,34.29-66.95-4.29.92,65.67-43.34-1.86-1.82-172.37Z"/>
          <path class="cls-1" d="m2046.82,477.32l42.78,4.21,4.03,163.08-43.35-1.85-3.46-165.45Z"/>
          <path class="cls-1" d="m2160.17,488.46l71.27,107.3-3.78-100.65,39.59,3.88,6.35,153.34-50.06-2.14-70.66-105.31,3.09,102.41-39.84-1.7-4.32-161.88,48.35,4.75Z"/>
        </g>
        <g>
          <path class="cls-2" d="m2292.85,547.28c-.24-5.3,1.49-9.23,5.18-11.82,3.68-2.57,8.21-3.6,13.62-3.14,5.2.45,9.76,2.3,13.67,5.54,3.91,3.23,5.98,7.41,6.23,12.56.2,4.11-1.67,7.75-5.62,10.88-3.95,3.15-8.33,4.56-13.15,4.19-5.23-.39-9.8-2.4-13.73-6.04-3.92-3.64-5.99-7.7-6.18-12.17Zm23.41,86.08c-5.36-.27-10.03-1.98-14.05-5.15-4.02-3.19-6.15-7.46-6.38-12.84-.19-4.55,1.49-8.36,5.04-11.4,3.56-3.05,8.04-4.4,13.46-4.06,5.43.33,10.13,2.22,14.13,5.68,3.98,3.43,6.08,7.43,6.29,11.98.26,5.23-1.47,9.22-5.16,12-3.71,2.78-8.16,4.06-13.33,3.79Z"/>
          <path class="cls-2" d="m2391.25,588.2c.54,10.02-.56,19.23-3.28,27.67-2.72,8.44-7.1,16.99-13.15,25.64-3.39,4.87-6.14,7.9-8.19,9.11-2.07,1.18-4.94,1.71-8.6,1.54-2.73-.13-4.14-.82-4.21-2.06-.01-.42,1.02-2.59,3.13-6.53,2.09-3.93,4.24-8.61,6.45-14.06,2.2-5.43,4.02-11.86,5.46-19.26,1.43-7.4,1.94-15.23,1.52-23.49-.44-8.31-1.77-16.28-4-23.97-2.24-7.67-4.71-14.39-7.43-20.12-2.72-5.74-5.31-10.75-7.79-15.04-2.49-4.29-3.74-6.63-3.75-7.01-.07-1.24,1.27-1.74,3.96-1.5,3.78.37,6.74,1.26,8.85,2.67,2.11,1.4,5.09,4.82,8.93,10.24,3.43,4.77,6.45,9.43,9.06,13.98,2.61,4.54,4.84,9.05,6.66,13.49,1.84,4.47,3.3,9.08,4.35,13.83,1.08,4.76,1.75,9.71,2.03,14.85Z"/>
        </g>
        <path class="cls-1" d="m2045.24,266.62c.19,9.29-7.46,15.54-17.09,13.94-9.63-1.59-17.58-10.5-17.75-19.91-.17-9.4,7.49-15.64,17.09-13.95,9.6,1.71,17.56,10.63,17.75,19.91Z"/>
        <path class="cls-1" d="m2031.11,281.65c-1.02,0-2.06-.09-3.1-.26-10-1.65-18.27-10.95-18.45-20.73-.07-4.2,1.37-8.02,4.08-10.77,3.41-3.47,8.57-4.95,13.98-4,9.99,1.77,18.25,11.06,18.45,20.72.09,4.14-1.34,7.93-4.02,10.68-2.76,2.83-6.64,4.36-10.93,4.36Zm-6.75-34.38c-3.75,0-7.14,1.35-9.54,3.79-2.38,2.43-3.65,5.83-3.6,9.58.18,9.01,7.84,17.57,17.06,19.09,4.91.82,9.54-.53,12.57-3.61,2.37-2.43,3.63-5.8,3.56-9.49-.2-8.9-7.85-17.47-17.08-19.1-.99-.19-1.99-.27-2.97-.27Z"/>
        <path class="cls-1" d="m2277.88,306.48c.36,8.56-7.15,14.21-16.77,12.62-9.65-1.6-17.75-9.92-18.08-18.59-.35-8.67,7.15-14.32,16.77-12.61,9.62,1.7,17.7,10.02,18.08,18.59Z"/>
        <path class="cls-1" d="m2264.3,320.2c-1.09,0-2.21-.09-3.33-.28-9.99-1.66-18.41-10.34-18.76-19.38-.16-3.73,1.05-7.03,3.46-9.56,3.32-3.45,8.62-4.93,14.28-3.92,9.95,1.77,18.37,10.46,18.76,19.39.17,3.67-1.03,6.94-3.42,9.44-2.67,2.78-6.56,4.31-10.99,4.31Zm-7.86-31.78c-3.86,0-7.26,1.33-9.57,3.73-2.09,2.17-3.14,5.06-3.01,8.33.33,8.29,8.13,16.27,17.37,17.79,5.14.85,9.92-.47,12.85-3.53,2.08-2.17,3.1-5.01,2.96-8.23-.35-8.17-8.14-16.16-17.38-17.8-1.09-.19-2.17-.29-3.22-.29Z"/>
        <g>
          <path class="cls-1" d="m1979.98,672.13l18.42.88-.08,3.08-15.2-.7-.23,9.9,15.08.67-.07,3.09-15.07-.64-.29,12.44,15.07.59-.07,3.09-18.28-.7.73-31.68Z"/>
          <path class="cls-1" d="m2003.5,673.25l3.21.15-.65,28.4,12.36.48-.07,3.03-15.58-.6.73-31.46Z"/>
          <path class="cls-1" d="m2035.66,674.79l16.1.76-.07,3.04-12.88-.6-.23,9.75,12.89.55-.07,3.04-12.89-.54-.35,15.27-3.22-.12.73-31.15Z"/>
          <path class="cls-1" d="m2056.45,675.77l3.22.15-.74,30.92-3.21-.12.73-30.96Z"/>
          <path class="cls-1" d="m2065.86,707.11l.73-30.87.69.03,20.84,24.49.56-23.5,3.16.15-.73,30.62-.72-.03-20.66-24.13-.55,23.34-3.32-.11Z"/>
          <path class="cls-1" d="m2110.42,708.76l.74-30.44,6.66.3c4.81.22,8.28.75,10.44,1.57,3.09,1.17,5.48,3.06,7.18,5.67,1.7,2.61,2.5,5.66,2.41,9.16-.07,3.02-.83,5.65-2.28,7.91-1.45,2.23-3.29,3.86-5.54,4.88-2.24,1.02-5.37,1.45-9.38,1.3l-10.23-.37Zm3.16-2.76l3.71.14c4.45.16,7.53.02,9.26-.44,2.44-.64,4.37-1.91,5.8-3.78,1.43-1.87,2.18-4.19,2.25-6.97.07-2.91-.63-5.44-2.07-7.57-1.45-2.13-3.5-3.64-6.16-4.53-2-.67-5.3-1.1-9.92-1.32l-2.27-.1-.59,24.56Z"/>
          <path class="cls-1" d="m2144.03,679.83l18.41.85-.07,2.93-15.21-.69-.22,9.43,15.07.64-.07,2.93-15.08-.61-.29,11.83,15.08.56-.08,2.93-18.28-.67.73-30.12Z"/>
          <path class="cls-1" d="m2175.57,705.58l2.77-1.43c1.84,3.36,4.02,5.08,6.54,5.16,1.07.04,2.1-.15,3.05-.58.95-.43,1.69-1.02,2.21-1.8.51-.76.77-1.58.8-2.45.02-.99-.32-1.98-1.03-2.97-.97-1.36-2.76-3.02-5.38-4.98-2.64-2-4.27-3.41-4.91-4.28-1.11-1.44-1.64-2.99-1.6-4.63.03-1.3.41-2.46,1.09-3.5.7-1.04,1.66-1.84,2.89-2.4,1.23-.55,2.56-.8,4-.73,1.51.07,2.92.48,4.22,1.24,1.3.75,2.66,2.08,4.09,4.01l-2.67,1.72c-1.18-1.54-2.17-2.55-3.02-3.06-.84-.5-1.76-.79-2.77-.83-1.3-.05-2.36.26-3.21.95-.84.69-1.27,1.57-1.3,2.64-.02.65.11,1.28.39,1.9.27.62.79,1.3,1.55,2.04.41.4,1.77,1.45,4.07,3.15,2.74,2,4.61,3.77,5.61,5.28,1,1.52,1.47,3.03,1.44,4.52-.05,2.15-.98,3.98-2.8,5.5-1.81,1.53-3.99,2.24-6.51,2.16-1.95-.08-3.71-.62-5.27-1.64-1.57-1.03-3-2.7-4.28-5.01Z"/>
          <path class="cls-1" d="m2201.34,682.44l18.41.83-.06,2.89-15.21-.67-.23,9.26,15.07.62-.07,2.88-15.07-.6-.29,11.61,15.08.55-.07,2.89-18.28-.65.72-29.59Z"/>
          <path class="cls-1" d="m2222.67,712.81l5.33-29.17.52.02,12.47,24.54,13.54-23.38.51.02,3.89,29.23-3.15-.11-2.65-20.91-11.89,20.41-.82-.03-10.97-21.53-3.68,21.01-3.1-.11Z"/>
          <path class="cls-1" d="m2278.65,685.89l14.25,29.36-3.47-.12-4.81-9.65-13.85-.52-5.24,9.34-3.58-.12,15.91-28.33.78.03Zm-.56,6.11l-5.77,10.23,10.98.43-5.21-10.66Z"/>
          <path class="cls-1" d="m2297.47,715.41l.73-28.67.7.03,20.83,22.75.56-21.82,3.18.15-.74,28.42-.72-.02-20.66-22.41-.55,21.69-3.32-.11Z"/>
          <path class="cls-1" d="m2343.94,688.73l14.26,28.74-3.46-.12-4.82-9.45-13.83-.51-5.25,9.15-3.59-.12,15.92-27.73.78.03Zm-.55,5.99l-5.77,10.01,10.98.41-5.22-10.42Z"/>
          <path class="cls-1" d="m1933.5,746.72l5.33-31.96h.53s12.46,26.69,12.46,26.69l13.54-25.76h.52s3.89,31.97,3.89,31.97l-3.14-.09-2.66-22.85-11.88,22.49-.82-.03-10.98-23.42-3.68,23.04-3.1-.09Z"/>
          <path class="cls-1" d="m1989.48,716.53l14.26,31.99-3.47-.09-4.81-10.51-13.84-.39-5.25,10.3-3.58-.09,15.91-31.24.78.03Zm-.56,6.7l-5.77,11.28,10.99.32-5.22-11.6Zm1.78-15.76l4.69.18-6.59,6.37-3.02-.1,4.92-6.44Z"/>
          <path class="cls-1" d="m2005.09,742.69l2.77-1.53c1.84,3.5,4.03,5.29,6.55,5.36,1.07.02,2.1-.19,3.05-.65.96-.47,1.7-1.1,2.21-1.92.52-.8.78-1.68.8-2.6.02-1.06-.32-2.09-1.02-3.11-.97-1.42-2.76-3.15-5.39-5.19-2.64-2.06-4.27-3.54-4.91-4.44-1.1-1.51-1.63-3.14-1.58-4.85.03-1.37.39-2.61,1.09-3.71.7-1.1,1.66-1.96,2.89-2.56,1.23-.6,2.55-.88,3.99-.83,1.51.06,2.92.47,4.22,1.24,1.3.77,2.66,2.17,4.09,4.17l-2.67,1.85c-1.17-1.59-2.18-2.65-3.02-3.19-.84-.53-1.76-.8-2.77-.84-1.3-.03-2.36.31-3.21,1.05-.84.74-1.27,1.67-1.3,2.8-.01.68.11,1.35.39,2,.28.65.79,1.36,1.54,2.14.42.42,1.77,1.5,4.08,3.26,2.74,2.09,4.61,3.93,5.6,5.52,1,1.58,1.48,3.17,1.45,4.73-.06,2.27-.99,4.22-2.79,5.85-1.81,1.63-3.98,2.42-6.52,2.36-1.95-.05-3.7-.6-5.26-1.66-1.57-1.06-2.99-2.81-4.28-5.23Z"/>
          <path class="cls-1" d="m2042.87,718.37l6.34.21c2.54.09,4.49.45,5.85,1.07,1.36.64,2.42,1.56,3.19,2.8.76,1.23,1.13,2.57,1.09,4.06-.03,1.37-.41,2.61-1.13,3.72-.72,1.11-1.76,1.99-3.13,2.65,1.66.6,2.93,1.28,3.81,2.04.88.76,1.56,1.67,2.03,2.73.48,1.06.71,2.19.67,3.41-.05,2.48-1.05,4.55-2.98,6.22-1.92,1.67-4.48,2.47-7.64,2.39l-8.83-.21.73-31.1Zm2.76,16.22l-.28,11.91,3.99.1c2.35.06,4.08-.11,5.18-.53,1.1-.42,2-1.09,2.69-2.01.68-.93,1.04-1.93,1.06-3.03.03-1.37-.41-2.58-1.32-3.63-.9-1.05-2.17-1.79-3.81-2.21-1.08-.29-2.98-.47-5.7-.54l-1.82-.06Zm.31-13.07l-.23,9.95,1.84.05c2.24.07,3.88-.08,4.94-.46,1.06-.37,1.91-.97,2.54-1.82.64-.84.97-1.79.99-2.85.04-1.41-.46-2.54-1.46-3.38-1.01-.84-2.64-1.3-4.89-1.37l-3.73-.13Z"/>
          <path class="cls-1" d="m2081.15,719.67l14.26,31.08-3.47-.07-4.81-10.23-13.85-.37-5.25,10.01-3.58-.09,15.91-30.37.79.03Zm-.56,6.51l-5.78,10.97,10.99.32-5.21-11.29Z"/>
          <path class="cls-1" d="m2100.84,720.32l6.41.21c3.56.12,5.98.35,7.24.66,1.9.47,3.42,1.41,4.59,2.8,1.16,1.4,1.72,3.09,1.67,5.07-.04,1.66-.48,3.1-1.34,4.32-.85,1.24-2.05,2.15-3.59,2.76-1.55.59-3.67.86-6.36.81l11.22,14.41-3.97-.09-11.22-14.44-1.82-.05-.34,14.17-3.21-.08.73-30.55Zm3.14,3.1l-.24,10.37,5.53.21c2.15.05,3.73-.09,4.78-.45,1.03-.36,1.86-.95,2.45-1.78.59-.83.91-1.77.93-2.81.02-1.02-.24-1.96-.81-2.82-.56-.84-1.32-1.47-2.26-1.85-.93-.38-2.51-.61-4.7-.68l-5.67-.19Z"/>
          <path class="cls-1" d="m2140.51,721.63l14.26,30.52-3.47-.07-4.82-10.03-13.84-.37-5.25,9.84-3.58-.07,15.91-29.83.79.03Zm-.56,6.4l-5.77,10.77,10.99.31-5.22-11.08Z"/>
          <path class="cls-1" d="m2153.14,724.99l.06-2.94,17.62.57-.07,2.92-7.17-.22-.66,27.02-3.28-.08.67-27.05-7.17-.22Z"/>
          <path class="cls-1" d="m2190.32,722.5c4.87.15,8.9,1.79,12.11,4.88,3.2,3.09,4.75,6.81,4.64,11.17-.1,4.32-1.82,7.96-5.17,10.88-3.35,2.95-7.38,4.36-12.09,4.26-4.76-.1-8.75-1.71-11.95-4.81-3.21-3.11-4.75-6.82-4.65-11.12.07-2.87.88-5.51,2.43-7.9,1.56-2.41,3.64-4.26,6.26-5.56,2.61-1.3,5.42-1.9,8.42-1.8Zm.08,2.89c-2.38-.08-4.65.42-6.8,1.5-2.16,1.08-3.86,2.57-5.1,4.49-1.24,1.91-1.9,4.07-1.95,6.46-.09,3.55,1.16,6.57,3.75,9.08,2.59,2.51,5.75,3.8,9.49,3.88,2.49.06,4.81-.44,6.96-1.5,2.15-1.07,3.85-2.55,5.08-4.45,1.23-1.9,1.88-4.03,1.93-6.39.06-2.35-.48-4.48-1.62-6.42-1.14-1.94-2.77-3.51-4.9-4.72-2.14-1.21-4.41-1.85-6.83-1.92Z"/>
          <path class="cls-1" d="m2224.65,753.73l.72-29.36,6.67.21c4.81.15,8.28.61,10.44,1.37,3.09,1.09,5.48,2.88,7.18,5.38,1.69,2.49,2.5,5.43,2.41,8.8-.07,2.92-.83,5.47-2.28,7.64-1.44,2.19-3.29,3.79-5.54,4.79-2.24,1.01-5.37,1.48-9.38,1.39l-10.22-.23Zm3.14-2.7l3.72.09c4.44.1,7.52-.08,9.26-.55,2.43-.66,4.37-1.9,5.79-3.72,1.43-1.83,2.19-4.09,2.25-6.75.08-2.82-.62-5.24-2.07-7.28-1.46-2.03-3.51-3.47-6.17-4.28-2-.62-5.29-1-9.91-1.14l-2.28-.07-.59,23.7Z"/>
          <path class="cls-1" d="m2258.24,725.39l18.42.58-.06,2.82-15.21-.45-.23,9.1,15.07.41-.08,2.82-15.07-.39-.29,11.41,15.08.33-.08,2.83-18.28-.39.72-29.06Z"/>
          <path class="cls-1" d="m2281.77,726.11l3.21.11-.66,26.02,12.36.27-.07,2.77-15.58-.33.73-28.84Z"/>
          <path class="cls-1" d="m2327.05,727.51l14.26,28.71-3.47-.07-4.81-9.43-13.84-.33-5.25,9.27-3.58-.08,15.91-28.09.79.03Zm-.56,6.02l-5.78,10.15,10.99.27-5.21-10.42Z"/>
          <path class="cls-1" d="m2345.86,756.31l.73-28.21h.7s20.83,22.12,20.83,22.12l.56-21.47,3.17.09-.73,27.98-.71-.02-20.66-21.77-.55,21.35-3.33-.07Zm20-33.72l1.47,1.89c-1.06.63-1.96,1.06-2.68,1.27-.72.21-1.49.3-2.29.28-1.05-.03-2.12-.31-3.23-.81-.93-.44-1.53-.69-1.78-.76-.36-.1-.73-.15-1.14-.16-.52-.02-1,.04-1.46.19-.46.15-1.13.48-2.03,1.02l-1.39-2c1.36-1.2,3.01-1.78,4.96-1.72.93.03,2.04.33,3.32.89,1.23.55,2.19.83,2.9.86.8.03,1.91-.29,3.33-.94Z"/>
          <path class="cls-1" d="m2394.54,728.81c4.87.14,8.91,1.66,12.12,4.56,3.19,2.88,4.75,6.36,4.64,10.43-.11,4.04-1.83,7.44-5.17,10.19-3.35,2.76-7.38,4.08-12.09,3.99-4.76-.09-8.75-1.59-11.95-4.49-3.21-2.91-4.76-6.37-4.65-10.4.06-2.67.88-5.14,2.44-7.39,1.55-2.24,3.63-3.98,6.24-5.2,2.61-1.22,5.42-1.78,8.42-1.7Zm.08,2.71c-2.37-.07-4.65.4-6.8,1.41-2.17,1.01-3.86,2.41-5.1,4.2-1.25,1.79-1.89,3.8-1.95,6.04-.08,3.32,1.16,6.15,3.75,8.49,2.59,2.34,5.75,3.54,9.48,3.62,2.49.05,4.82-.43,6.97-1.43,2.15-.99,3.84-2.38,5.08-4.16,1.24-1.78,1.89-3.77,1.94-5.98.06-2.19-.49-4.19-1.62-5.99-1.14-1.81-2.78-3.27-4.91-4.4-2.13-1.13-4.41-1.73-6.82-1.79Z"/>
        </g>
      </g>
      <g>
        <path class="cls-4" d="m1912.86,821.79h.23s-.65,29.29-.65,29.29l-4.53-.1.51-23.05-6.57,2.33.09-4.16,10.92-4.32Z"/>
        <path class="cls-4" d="m1976.51,852.61l-2.79-7.76-13.27-.29-3.13,7.63-4.99-.11,12.74-30.21,5.08.11,11.35,30.74-4.99-.11Zm-14.44-12l10.22.23-4.79-13.38-5.42,13.16Z"/>
        <path class="cls-4" d="m1990.66,848.76l12.8.28-.09,4.16-17.57-.39.67-30.48,4.76.11-.58,26.32Z"/>
        <path class="cls-4" d="m2027.09,824.43h.23s-.65,29.29-.65,29.29l-4.53-.1.51-23.04-6.57,2.33.09-4.16,10.92-4.32Z"/>
        <path class="cls-4" d="m2033.83,824.98l20.99.46v.35s-16.45,28.18-16.45,28.18l-5.36-.12,14.37-24.51-13.64-.3.09-4.07Z"/>
        <path class="cls-4" d="m2083.52,824.48c9.11.2,14.28,6.95,14.09,15.62-.19,8.63-5.65,15.05-14.76,14.85l-12.39-.27.67-30.48,12.39.27Zm-.58,26.32c6.38.14,9.77-4.61,9.91-10.8.14-6.19-3.04-11.22-9.42-11.36l-7.63-.17-.49,22.16,7.63.17Z"/>
        <path class="cls-4" d="m2108.69,851.36l14.79.33-.09,4.16-19.51-.43.67-30.48,19.09.42-.09,4.16-14.38-.32-.2,9.24,12.53.28-.09,4.2-12.53-.28-.19,8.71Z"/>
        <path class="cls-4" d="m2160.63,826.18l4.76.1-.67,30.48-4.48-.1-13.43-22.51-.49,22.2-4.76-.11.67-30.48,4.62.1,13.29,22.33.48-22.03Z"/>
        <path class="cls-4" d="m2171.53,841.73c.19-8.67,7.38-15.68,16.44-15.48,9.11.2,16.02,7.52,15.83,16.19-.19,8.63-7.42,15.55-16.53,15.35-9.06-.2-15.93-7.43-15.74-16.06Zm27.51.61c.14-6.28-4.65-11.7-11.16-11.84-6.47-.14-11.44,5.06-11.58,11.34-.14,6.24,4.6,11.56,11.07,11.71,6.52.14,11.53-4.97,11.67-11.2Z"/>
        <path class="cls-4" d="m2225.54,827.61l4.9.11-10.24,30.27-4.44-.1-8.99-30.69,4.9.11,6.43,23.06,7.44-22.76Z"/>
        <path class="cls-4" d="m2235.23,858.31l.67-30.48,4.76.11-.67,30.48-4.76-.1Z"/>
        <path class="cls-4" d="m2253.4,854.55l14.79.33-.09,4.16-19.51-.43.67-30.48,19.09.42-.09,4.16-14.38-.32-.2,9.24,12.53.28-.09,4.2-12.53-.28-.19,8.71Z"/>
        <path class="cls-4" d="m2311.14,859.98l-4.72-.1-2.33-22.18-9.89,18.55-4.07-.09-9.16-18.97-3.31,22.06-4.72-.1,4.55-30.39,4.25.09,10.47,22.18,11.44-21.7,4.25.09,3.21,30.56Z"/>
        <path class="cls-4" d="m2340.73,852.01c-.1,4.38-3.57,8.55-9.67,8.42l-13.13-.29.67-30.48,12.11.27c5.41.12,8.71,3.29,8.61,8.02-.05,2.52-1.09,5.24-4.21,6.32,3.77.84,5.68,4.42,5.61,7.74Zm-10.5,4.24c3.7.08,5.69-2.13,5.75-4.79.05-2.48-1.6-4.99-5.3-5.07l-7.67-.17-.22,9.86,7.44.16Zm.3-22.16l-7.26-.16-.19,8.4,7.35.16c2.63.06,4.06-1.68,4.11-4.16.05-2.39-1.3-4.19-4.02-4.25Z"/>
        <path class="cls-4" d="m2363.66,861.14l-7.93-11.55-3.6-.08-.25,11.37-4.76-.1.67-30.48,12.16.27c6.98.15,9.69,5.04,9.59,9.86-.1,4.38-2.97,8.92-8.3,9.29l8.12,11.55-5.69-.13Zm-11.21-26.58l-.24,10.97,6.24.14c4.39.1,6.24-2.12,6.32-5.35.07-3.19-1.87-5.53-4.96-5.6l-7.35-.16Z"/>
        <path class="cls-4" d="m2380.62,857.36l14.79.33-.09,4.16-19.51-.43.67-30.48,19.09.42-.09,4.16-14.38-.32-.2,9.24,12.53.28-.09,4.2-12.53-.28-.19,8.71Z"/>
        <path class="cls-4" d="m1938.44,843.12c-.06,5.41-4.38,9.1-10.42,9.03-4.19-.05-7.72-2.29-9.53-6.1l3.49-2.08c1.37,2.49,3.47,4,5.9,4.03,3.52.04,6.06-2.01,6.09-4.89.03-3.15-2.46-5.3-5.93-5.34l-3.02-.03.04-3.65,2.57.03c3.11.03,5.11-1.75,5.1-4.27.03-2.34-1.76-3.85-4.37-3.88-1.98-.02-4.02.99-5.17,2.6l-2.85-2.6c1.65-2.55,4.82-4.23,8.25-4.19,5.18.06,8.66,3.25,8.61,8.03-.03,2.7-1.5,4.98-3.81,6.04,3.05,1.07,5.09,3.8,5.05,7.27Z"/>
      </g>
    </g>
    <g>
      <g>
        <g>
          <ellipse class="cls-3" cx="1748.21" cy="178" rx="143.59" ry="122.4"/>
          <path class="cls-4" d="m1604.62,178c.14-74.4,74.25-123.63,143.59-122.6,69.45-1.16,143.73,48.08,143.98,122.6-.26,74.52-74.52,123.76-143.98,122.6-69.32,1.04-143.47-48.21-143.59-122.6h0Zm0,0c.27,74.3,74.34,123.37,143.59,122.21,69.12,1.03,143.07-48.04,143.2-122.21-.14-74.18-74.08-123.24-143.21-122.21-69.24-1.16-143.34,47.92-143.59,122.21h0Z"/>
        </g>
        <g>
          <path class="cls-4" d="m1752.87,203.85h-51.81v-6.02h4.12c2.27,0,4.31-.29,6.12-.88,1.81-.59,2.71-1.91,2.71-3.96,0-1-1.16-3.05-3.47-6.15l-14.33-18.9-13.8,16.09c-3.23,3.66-4.84,6.48-4.84,8.44,0,1.62.53,2.83,1.6,3.63,1.07.8,2.36,1.3,3.89,1.47,1.53.17,3.58.26,6.15.26v6.02h-38.99v-6.02c2.83-.09,5.35-.5,7.55-1.24,2.2-.74,4.68-2.3,7.43-4.68,2.75-2.37,6.34-6.16,10.79-11.35l15.77-18.51-21.39-28.13c-3.23-4.19-5.56-7.03-7-8.54-1.44-1.51-3.12-2.59-5.04-3.24-1.92-.66-4.62-.98-8.11-.98v-6.02h48.41v6.02h-3.4c-2.48,0-4.35.19-5.59.56-1.24.37-1.86,1.36-1.86,2.98,0,.96,1.33,3.31,3.99,7.06l12.36,15.96,14.07-16.49c1.26-1.66,2.09-2.82,2.48-3.5.39-.67.59-1.51.59-2.52,0-1.44-.55-2.47-1.63-3.11-1.09-.63-3.14-.95-6.15-.95h-3.07v-6.02h36.7v6.02c-3.36,0-6.23.53-8.6,1.6-2.38,1.06-4.47,2.47-6.28,4.22-1.81,1.75-4.44,4.6-7.88,8.57l-15.83,18.19,21.59,28.26c3.23,4.28,5.88,7.5,7.95,9.68,2.07,2.18,4.18,3.73,6.31,4.64,2.14.92,4.97,1.42,8.5,1.5v6.02Z"/>
          <path class="cls-4" d="m1851.4,121.17c-2.09.04-3.91.33-5.46.85-1.55.53-2.82,1.34-3.83,2.46-1,1.11-2.01,2.63-3.01,4.55-1,1.92-2.4,4.93-4.19,9.03l-28.92,67.44h-6.08l-30.22-70.78c-1.88-4.4-3.34-7.43-4.38-9.09-1.05-1.66-2.44-2.81-4.19-3.46-1.75-.66-4.34-.98-7.79-.98v-6.02h45.14v6.02c-4.28.17-7.24.52-8.9,1.05-1.66.52-2.49,1.83-2.49,3.93,0,1.96.52,4.06,1.57,6.28l20.41,47.43,18.84-44.29c1.61-3.84,2.42-6.48,2.42-7.92,0-2.83-.98-4.6-2.94-5.3-1.96-.7-4.91-1.09-8.83-1.18v-6.02h32.84v6.02Z"/>
        </g>
      </g>
      <g>
        <path class="cls-4" d="m1659.05,236.95h-9.72v-1.4c.82,0,1.42-.06,1.8-.17.38-.12.56-.4.56-.83,0-.3-.06-.61-.18-.93l-.97-2.43h-6.69l-.5,1.34c-.28.75-.43,1.29-.43,1.63,0,.61.23,1,.71,1.16.47.16,1.02.24,1.65.24v1.4h-7.1v-1.4c.57,0,1.05-.1,1.45-.32.4-.21.77-.61,1.13-1.21.36-.59.75-1.43,1.16-2.52l5.95-15.58h1.45l6.28,16.07c.46,1.13.79,1.9,1,2.3.21.4.51.71.88.93.38.22.9.33,1.58.33v1.4Zm-9.07-7.26l-2.84-7.19-2.71,7.19h5.55Z"/>
        <path class="cls-4" d="m1682.51,217.72c-.98,0-1.69.1-2.11.3-.43.2-.69.49-.79.88-.1.38-.15,1.01-.15,1.89v16.35h-1.4l-13.49-16.04v11.37c0,.86.05,1.49.16,1.88.1.39.38.69.81.9.44.21,1.14.31,2.11.31v1.4h-7.67v-1.4c.91,0,1.58-.1,1.98-.31.41-.21.67-.5.76-.9.1-.39.15-1.02.15-1.88v-10.53c0-.85-.02-1.5-.07-1.92-.05-.43-.16-.8-.33-1.12-.17-.32-.45-.58-.85-.77-.39-.2-.93-.33-1.62-.4v-1.4h6.01l11.74,13.87v-9.42c0-.77-.05-1.36-.16-1.77-.1-.41-.37-.73-.79-.95-.42-.22-1.09-.33-2-.33v-1.4h7.7v1.4Z"/>
        <path class="cls-4" d="m1694.06,236.95h-10.47v-1.4c.87,0,1.53-.08,1.98-.25.45-.17.74-.42.88-.75.13-.33.2-.81.2-1.43v-12.96c0-.89-.18-1.52-.56-1.89-.37-.37-1.2-.55-2.5-.55v-1.4h10.47v1.4c-.87,0-1.53.09-1.98.26-.45.17-.74.42-.88.75-.13.33-.2.8-.2,1.42v12.96c0,.59.07,1.05.2,1.38.13.34.41.6.85.78.43.18,1.1.27,2.01.27v1.4Z"/>
        <path class="cls-4" d="m1717.93,217.72c-.49,0-.91.08-1.27.2-.36.12-.66.31-.89.57-.23.26-.47.61-.7,1.06-.23.45-.56,1.15-.97,2.1l-6.72,15.69h-1.41l-7.03-16.47c-.44-1.02-.78-1.73-1.02-2.11-.24-.39-.57-.65-.97-.81-.41-.15-1.01-.23-1.81-.23v-1.4h10.5v1.4c-.99.04-1.68.12-2.07.24-.38.12-.58.43-.58.91,0,.46.12.94.37,1.46l4.75,11.03,4.38-10.3c.38-.89.56-1.5.56-1.84,0-.66-.23-1.07-.68-1.23-.46-.16-1.14-.25-2.05-.27v-1.4h7.64v1.4Z"/>
        <path class="cls-4" d="m1737.64,230.16l-.17,6.79h-18.38v-1.4c1.27,0,2.08-.18,2.45-.55.37-.37.55-1,.55-1.89v-12.96c0-.59-.06-1.05-.17-1.38-.12-.33-.39-.59-.82-.77-.43-.19-1.1-.28-2-.28v-1.4h17.12l.27,5.36h-1.4c-.32-1.19-.68-2.03-1.09-2.55-.41-.51-.87-.83-1.39-.94-.51-.12-1.28-.18-2.3-.18h-3.86v7.29h2.1c.72,0,1.26-.07,1.61-.19.35-.13.6-.37.75-.72s.24-.91.29-1.67h1.46v6.86h-1.4c-.04-.76-.14-1.32-.3-1.68s-.42-.6-.77-.72c-.35-.12-.88-.18-1.6-.18h-2.13v4.85c0,.81.02,1.4.06,1.78.04.37.15.69.33.93.18.25.47.43.87.54.4.11.97.17,1.71.17h1.66c.7,0,1.37-.09,2-.27.63-.18,1.26-.63,1.86-1.37.61-.73,1.03-1.89,1.28-3.46h1.43Z"/>
        <path class="cls-4" d="m1761.85,236.95h-5.52c-.2-.22-.45-.55-.75-.97-.3-.43-.63-.93-.98-1.5-.35-.57-.65-1.05-.88-1.42l-1.4-2.31c-.63-1.03-1.1-1.74-1.42-2.12-.32-.38-.68-.63-1.1-.73-.41-.11-1.11-.16-2.09-.16h-.78v5.39c0,.57.06,1.03.18,1.37.12.34.41.61.86.79.45.18,1.11.27,1.97.27v1.4h-10.35v-1.4c1.26,0,2.07-.18,2.43-.55.36-.37.54-1,.54-1.89v-13.02c0-.88-.17-1.51-.53-1.88-.35-.37-1.16-.56-2.44-.56v-1.43l4.78-.15c.37-.02.78-.03,1.25-.04.47-.01.91-.02,1.32-.02.32,0,.84,0,1.57.03,1.02.03,1.98.09,2.88.18.89.09,1.6.21,2.11.35.76.19,1.48.51,2.17.96.69.45,1.24,1.03,1.67,1.76.43.73.65,1.58.65,2.54,0,.69-.15,1.36-.45,2.01-.3.65-.78,1.23-1.45,1.74-.66.5-1.54.9-2.62,1.2.74.43,1.37.98,1.89,1.62.52.64,1.33,1.83,2.43,3.55.64.98,1.17,1.73,1.58,2.23.42.5.8.84,1.15,1.02.35.18.79.29,1.33.34v1.4Zm-8.55-15.14c0-1.64-.5-2.73-1.5-3.27-1-.54-2.3-.8-3.92-.8-.22,0-.4,0-.53,0-.13,0-.27,0-.43,0v8.29h.96c1.53,0,2.82-.25,3.86-.74,1.04-.5,1.56-1.66,1.56-3.48Z"/>
        <path class="cls-4" d="m1778.35,231.03c0,.64-.14,1.32-.41,2.03-.27.71-.69,1.4-1.24,2.05-.55.66-1.25,1.19-2.09,1.6-.84.41-1.81.62-2.92.62s-2.18-.24-3.26-.72c-1.08-.48-2-1.19-2.75-2.13-.32.75-.53,1.45-.62,2.08h-1.4v-7.06h1.4c.25,1.02.6,1.97,1.05,2.86.45.9,1.08,1.66,1.9,2.31.82.64,1.82.96,3,.96,1.03,0,1.86-.28,2.49-.85.63-.57.94-1.28.94-2.14,0-.49-.1-.91-.29-1.28-.19-.37-.47-.7-.84-.98-.37-.29-.87-.6-1.5-.93-.63-.33-1.36-.68-2.17-1.04-1.25-.59-2.27-1.18-3.07-1.78-.8-.6-1.41-1.18-1.82-1.74-.41-.56-.7-1.1-.85-1.6-.16-.51-.24-1.02-.24-1.53,0-.93.25-1.83.75-2.73.5-.9,1.23-1.63,2.18-2.2.96-.57,2.07-.86,3.33-.86.96,0,1.88.22,2.75.65.87.43,1.63,1.02,2.27,1.77.18-.43.35-1.02.5-1.79h1.43v5.75h-1.43c-1.01-3.13-2.78-4.7-5.29-4.7-.91,0-1.65.24-2.2.72-.55.48-.83,1.1-.83,1.86,0,.6.17,1.12.52,1.56.35.44.8.82,1.36,1.13.57.31,1.47.77,2.73,1.35,1.52.72,2.71,1.34,3.57,1.87.86.53,1.58,1.19,2.18,1.99.59.8.89,1.77.89,2.9Z"/>
        <path class="cls-4" d="m1800.87,236.95h-9.72v-1.4c.82,0,1.42-.06,1.8-.17.38-.12.56-.4.56-.83,0-.3-.06-.61-.18-.93l-.97-2.43h-6.69l-.5,1.34c-.28.75-.43,1.29-.43,1.63,0,.61.23,1,.71,1.16.47.16,1.02.24,1.65.24v1.4h-7.1v-1.4c.57,0,1.05-.1,1.45-.32.4-.21.77-.61,1.13-1.21.36-.59.75-1.43,1.16-2.52l5.95-15.58h1.45l6.28,16.07c.46,1.13.79,1.9,1,2.3.21.4.51.71.88.93.38.22.9.33,1.58.33v1.4Zm-9.07-7.26l-2.84-7.19-2.71,7.19h5.55Z"/>
        <path class="cls-4" d="m1824.21,236.95h-5.52c-.2-.22-.45-.55-.75-.97-.3-.43-.63-.93-.98-1.5-.35-.57-.65-1.05-.88-1.42l-1.4-2.31c-.63-1.03-1.1-1.74-1.42-2.12-.32-.38-.68-.63-1.1-.73-.41-.11-1.11-.16-2.09-.16h-.78v5.39c0,.57.06,1.03.18,1.37.12.34.41.61.86.79.45.18,1.11.27,1.97.27v1.4h-10.35v-1.4c1.26,0,2.07-.18,2.43-.55.36-.37.54-1,.54-1.89v-13.02c0-.88-.17-1.51-.53-1.88-.35-.37-1.16-.56-2.44-.56v-1.43l4.78-.15c.37-.02.78-.03,1.25-.04.47-.01.91-.02,1.32-.02.32,0,.84,0,1.57.03,1.02.03,1.98.09,2.88.18.89.09,1.6.21,2.11.35.76.19,1.48.51,2.17.96.69.45,1.24,1.03,1.67,1.76.43.73.65,1.58.65,2.54,0,.69-.15,1.36-.45,2.01-.3.65-.78,1.23-1.45,1.74-.66.5-1.54.9-2.62,1.2.74.43,1.37.98,1.89,1.62.52.64,1.33,1.83,2.43,3.55.64.98,1.17,1.73,1.58,2.23.42.5.8.84,1.15,1.02.35.18.79.29,1.33.34v1.4Zm-8.55-15.14c0-1.64-.5-2.73-1.5-3.27-1-.54-2.3-.8-3.92-.8-.22,0-.4,0-.53,0-.13,0-.27,0-.43,0v8.29h.96c1.53,0,2.82-.25,3.86-.74,1.04-.5,1.56-1.66,1.56-3.48Z"/>
        <path class="cls-4" d="m1835.27,236.95h-10.47v-1.4c.87,0,1.53-.08,1.98-.25.45-.17.74-.42.88-.75.13-.33.2-.81.2-1.43v-12.96c0-.89-.18-1.52-.56-1.89-.37-.37-1.2-.55-2.5-.55v-1.4h10.47v1.4c-.87,0-1.53.09-1.98.26-.45.17-.74.42-.88.75-.13.33-.2.8-.2,1.42v12.96c0,.59.07,1.05.2,1.38.13.34.41.6.85.78.43.18,1.1.27,2.01.27v1.4Z"/>
        <path class="cls-4" d="m1860.39,226.63c0,1.88-.45,3.63-1.34,5.27-.89,1.64-2.21,2.95-3.96,3.94-1.75.99-3.81,1.49-6.2,1.49-1.95,0-3.66-.32-5.14-.95-1.48-.63-2.69-1.47-3.63-2.52-.94-1.06-1.63-2.21-2.08-3.47-.45-1.26-.68-2.52-.68-3.79,0-1.83.43-3.57,1.29-5.2.86-1.63,2.16-2.95,3.89-3.95,1.73-1,3.81-1.5,6.22-1.5,2.2,0,4.07.36,5.61,1.08,1.54.72,2.74,1.63,3.61,2.73.86,1.1,1.48,2.24,1.85,3.45.37,1.2.56,2.34.56,3.43Zm-4.93-.06c0-1.16-.1-2.25-.3-3.29-.2-1.03-.55-1.97-1.04-2.81-.5-.83-1.18-1.5-2.04-1.99-.86-.49-1.93-.74-3.19-.74-1.75,0-3.11.43-4.09,1.3-.98.87-1.64,1.95-1.99,3.26-.35,1.3-.53,2.73-.53,4.27,0,.85.06,1.74.17,2.66.11.92.38,1.86.81,2.83.43.97,1.11,1.79,2.04,2.45.93.67,2.14,1,3.62,1s2.66-.34,3.58-1.03c.92-.69,1.59-1.52,2.01-2.51.42-.99.69-1.93.79-2.84.11-.9.16-1.76.16-2.57Z"/>
      </g>
    </g>
  </g>
  <g>
    <path class="cls-4" d="m304.89,567.61h175.71v84.06h-175.71v-84.06Z"/>
    <path class="cls-4" d="m492.86,446.77c50.2,0,66.55-2.33,86.98-10.51,18.68-8.76,26.85-19.85,36.78-47.87h73.56v362.52h-86.98v-243.43h-110.33v-60.71Z"/>
    <path class="cls-4" d="m805.17,642.92c3.5,33.28,29.77,49.62,78.23,49.62,52.54,0,84.65-25.1,84.65-64.8s-30.94-62.46-84.06-62.46c-39.11,0-63.05,9.92-79.39,32.69h-85.81l37.94-209.57h269.12v69.47h-206.07l-11.68,62.46c22.77-18.1,56.63-26.85,98.66-26.85,54.29,0,98.07,16.93,123.18,47.87,18.1,21.6,28.02,50.79,28.02,80.56,0,88.15-65.38,141.27-174.55,141.27-102.16,0-169.88-46.7-172.8-120.26h94.57Z"/>
    <path class="cls-4" d="m1318.3,473.62c0,60.13-50.79,101.58-123.18,101.58-43.78,0-78.81-14.59-100.99-43.2-12.26-15.76-20.43-38.53-20.43-56.04,0-61.3,49.62-103.91,121.42-103.91s123.18,42.03,123.18,101.58Zm167.54-99.82h62.46l-407.47,389.38h-61.88l406.89-389.38Zm-350.26,101.58c0,32.69,26.27,58.38,59.54,58.38,36.19,0,60.71-24.52,60.71-60.13s-25.1-60.13-60.71-60.13-59.54,25.69-59.54,61.88Zm416.23,187.98c0,60.71-50.79,102.16-123.18,102.16-43.78,0-78.81-15.18-100.99-43.2-12.26-16.34-20.43-39.11-20.43-57.21,0-60.71,49.62-103.33,121.42-103.33s123.18,42.03,123.18,101.58Zm-182.14,1.17c0,33.28,25.69,58.96,58.96,58.96,36.19,0,60.71-24.52,60.71-60.13s-25.1-60.13-60.71-60.13-58.96,25.1-58.96,61.3Z"/>
  </g>
</svg>`
					 $('.product-card-'+ mainProduct +' .discount-season-badge').html(badge)
                   }
                   else{
                     $('.product-card-'+ mainProduct +' .discount-season-badge').html('')
                     $('.product-card-'+ mainProduct +' .compare_badge').css('display','flex')
					 $('.product-card-'+ mainProduct +' .compare_badge').text('-'+Math.ceil(100 - (parseFloat(productPrice.replace('$ ', '').replace(',', '')) * 100 / parseFloat(productCompare.replace('$ ', '').replace(',', ''))))+'%')
                   }
				}
				else{
                   $('.product-card-'+ mainProduct +' .discount-badge').css('display','none')
                   $('.product-card-'+ mainProduct +' .compare_badge').css('display','none')
					$('.product-card-'+ mainProduct +' .price-item.price-item--regular').text(productPrice)
					$('.product-card-'+ mainProduct +' .price').removeClass('price--on-sale')
					$('.product-card-'+ mainProduct +' .price__sale').css('display','none')
					$('.product-card-'+ mainProduct +' .price__regular').css('display','flex')
				}
				quickPurchase()
				/*
				const primaryImage = wrapper.querySelector(".media--first");
				const secondaryImage = wrapper.querySelector(".media--second");
				const handleProduct = wrapper.dataset.product;

				if (event.currentTarget.checked && primaryImage) {
					wrapper
						.querySelector(".js-color-swatches-link")
						.setAttribute("href", event.currentTarget.dataset.variantLink);
					const currentColor = event.currentTarget.value;

					jQuery.getJSON(
						window.Shopify.routes.root + `products/${handleProduct}.js`,
						function (product) {
							const variant = product.variants.filter(
								(item) =>
									item.featured_media != null &&
									item.options.includes(currentColor)
							)[0];
							if (variant) {
								const newPrimaryImage = createImageElement(
									variant["featured_media"],
									primaryImage.className,
									primaryImage.sizes,
									product.title
								);

								if (newPrimaryImage.src !== primaryImage.src) {
									let flag = false;
									if (secondaryImage) {
										const secondaryImagePathname = new URL(secondaryImage.src).pathname;
										const newPrimaryImagePathname = new URL(newPrimaryImage.src).pathname;

										if (secondaryImagePathname == newPrimaryImagePathname) {
											primaryImage.remove();
											secondaryImage.classList.remove("media--second");
											secondaryImage.classList.add("media--first");
											flag = true;
										}
									}
									if (flag == false) {
										primaryImage.animate(
											{ opacity: [1, 0] },
											{ duration: 200, easing: "ease-in", fill: "forwards" }
										).finished;
										setTimeout(function () {
											primaryImage.replaceWith(newPrimaryImage);
											newPrimaryImage.animate(
												{ opacity: [0, 1] },
												{ duration: 200, easing: "ease-in" }
											);
											if (secondaryImage) {
												secondaryImage.remove();
											}
										}, 200);
									}
								}
							}
						}
					);
				}
				*/
			});
		});
	});
	hideColorOptions()
};

const quickPurchase = () => {
	// $('.quick_add_btn').off('click').on('click', function() {
	// 	$(this).closest('.collection-product-card').find('.size__modal').toggleClass('op-1');
	//   });
	$('.size__btn').off('click').on('click', async function() {
      console.log('Entra al quick')
	  const color = $(this).attr('data-variantcolor');
	  const size = $(this).attr('data-variantsize');
	  const product = $(this).attr('data-product');
	  const secondProduct = $(this).attr('data-secondproduct');
	  var variantsInfo = JSON.parse(document.getElementById('variants_data_' + product).textContent);
		// console.log('Entra al quick')
	  for (const variant of variantsInfo) {
			if(variant.product == secondProduct){
				// console.log(variant)
				if (variant.title == size) {
					// console.log(variant.id);
                    let currentCart = await PCgetCurrentCart()
                    let hasGift = await PCcheckForGift(currentCart)
                    if(hasGift){
                        PChandleErrorMessage(product,"No puedes agregar un producto si tienes una Gift Card en tu carrito");
                        return
                    }
    				PChandleErrorMessage(product)

					let config = fetchConfig("javascript");
					config.headers["X-Requested-With"] = "XMLHttpRequest";
					delete config.headers["Content-Type"];
					const cart = document.querySelector("cart-drawer")
					const formData = new FormData();
					formData.append('TALLA', size);
					formData.append('form_type', 'product'); 
					formData.append('id', variant.id);
					formData.append('quantity', '1');
					formData.append('properties[color]', color);
					formData.append('product-id', product);
					if (cart) {
						formData.append(
							"sections",
							cart.getSectionsToRender().map((section) => section.id)
						);
						formData.append("sections_url", window.location.pathname);
						cart.setActiveElement(document.activeElement);
					}
					config.body = formData;
					fetch(`${routes.cart_add_url}`, config)
						.then((response) => response.json())
						.then((response) => {
  console.log('Antes de hacer upload')
							ncaddToken()
							uploadCart() 
                          executeInCartUpdate()
							if (response.status) {
								publish(PUB_SUB_EVENTS.cartError, {
									source: "product-form",
									productVariantId: formData.get("id"),
									errors: response.description,
									message: response.message,
								});
								PChandleErrorMessage(response.description);

								const soldOutMessage =
									this.submitButton.querySelector(".sold-out-message");
								if (!soldOutMessage) return;
								this.submitButton.setAttribute("aria-disabled", true);
								this.submitButton.querySelector("span").classList.add("hidden");
								soldOutMessage.classList.remove("hidden");
								this.error = true;
								return;
							} else if (!cart) {
								window.location = window.routes.cart_url;
								return;
							}

							if (!this.error)
								publish(PUB_SUB_EVENTS.cartUpdate, {
									source: "product-form",
									productVariantId: formData.get("id"),
								});
							this.error = false;
							const quickAddModal = this.closest("quick-add-modal");
							if (quickAddModal) {
								document.body.addEventListener(
									"modalClosed",
									() => {
										setTimeout(() => {
											cart.renderContents(response);
										});
									},
									{ once: true }
								);
								quickAddModal.hide(true);
							} else {
								cart.renderContents(response);
							}
						})
						.catch((e) => {
							console.error(e);
						})
				}
			}
	  }
	});
};

$(document).ready(function(){
	hideColorOptions()
})

function hideColorOptions(){
	$('.product-form__controls').on("mouseover",function(){
		if($(this).find(".more-elements")){
			$(this).find(".extra-element").each(function(){
				$(this).css('display','block')
			})
			$(this).find(".more-elements").css('display','none')
		}
	})
	$('.product-form__controls').on("mouseout",function(){
		if($(this).find(".more-elements")){
			$(this).find(".extra-element").each(function(){
				$(this).css('display','none')
			})
			$(this).find(".more-elements").css('display','block')
		}
	})
}


function colorSwatches() {
	checkSwatches();
	quickPurchase();

	document.addEventListener("shopify:section:load", function () {
		checkSwatches();
		quickPurchase();
	});
}

(function () {
	colorSwatches();
	quickPurchase();
})();

function toggleCheck(id){
	const element = document.getElementById(id);
	element.checked = !element.checked;
}



async function PCcheckForGift(cart){
  console.log('Revisa si hay Gift')
  let sku_list = ['9909909_000250','9909909_000500','9909909_000600','9909909_000700','9909909_000800','9909909_000900','9909909_001000','9909909_002000']
  for(let item of cart.items){
    if(sku_list.includes(item.sku)){
      return true
    }
  }
  return false
}

async function PCgetCurrentCart() {
	let cart
    await fetch('/cart.js')
    .then(response => {
      if (!response.ok) {
        return response.json().then(error => { throw new Error(error.message); });
      }
      return response.json();
    })
    .then(data => {
        cart = data
    })
    .catch((error) => {
      console.error('Error:', error);
    });
    return cart
  }

function PChandleErrorMessage(productid, errorMessage = false) {
	console.log(productid)
	let errorMessageWrapper = document.querySelector(".product-form__error-message-wrapper.pid-"+productid);
	if (!errorMessageWrapper) return;
	errorMessageContainer = errorMessageWrapper.querySelector(
			".product-form__error-message"
		);

	errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

	if (errorMessage) {
		errorMessageContainer.textContent = errorMessage;
	}
}